import { telHref } from '@/lib/format'

/**
 * Hand a number to the device's own phone app (`tel:`). This is what every
 * Call button falls back to when the business line (Twilio softphone) isn't
 * connected for this user (DECISIONS §15), so a Call button never dead-ends
 * on "Phone not connected".
 *
 * Kept as its own module so tests can spy on it without touching
 * window.location.
 */
export function openDeviceDialer(phone: string): void {
  if (typeof window === 'undefined') return
  window.location.href = telHref(phone)
}
